import React, { useState, useEffect } from "react";
import {
  AccountBookOutlined,
  BookOutlined,
  DashboardOutlined,
  HomeOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  MoonOutlined,
  NotificationFilled,
  ReadOutlined,
  SettingFilled,
  SignalFilled,
  SnippetsOutlined,
  SunOutlined,
  TrophyOutlined,
  UploadOutlined
} from "@ant-design/icons";
import { App, Button, Layout, Menu, Grid, Drawer, Row, Col, Dropdown } from "antd";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import Logo from "../assests/Shalina Healthcare Logo.pdf.png";
import Logo1 from "../assests/Shalina Healthcare Logo.pdf.png";

import { getUser, logout } from '../../authService';
import UserDropdown from '../components/UserDropdown';
import ThemeSetting from "../components/ThemeSetting";
import UserNotification from "../components/UserNotification";
import CulsightPageLoader from "../components/CulsightPageLoader";
import { Footer } from "antd/es/layout/layout";

const { Header, Sider, Content } = Layout;
const { useBreakpoint } = Grid;

const MasterTemplate = () => {
  const { modal } = App.useApp();
  const [user, setUser] = useState(null);
  const [master_loder, set_master_loder] = useState(true);
  const [collapsed, setCollapsed] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [openKeys, setOpenKeys] = useState([]);
  const [balck_theme, set_balck_theme] = useState("light");

  // responsive hook
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  useEffect(() => {
    getUser().then(usr => {
      setUser(usr);
      set_master_loder(false)
    });
  }, []);

  useEffect(() => {
    const pathToKey = {
      "/": { selected: "1" },
      "/courses": { selected: "2", open: "2" },
      "/view-course": { selected: "2", open: "2" },
      "/packages": { selected: "3", open: "3" },
      "/all-packages": { selected: "4", open: "4" },
      "/account": { selected: "7", open: "7" },
      "/certificate": { selected: "8", open: "8" },
      "/leaderboard": { selected: "9", open: "9" },
      "/view-announcements": { selected: "9", open: "9" },
    };

    const path = location.pathname;
    const match = pathToKey[path];
    if (match) {
      setSelectedKeys([match.selected]);
      if (match.open) {
        setOpenKeys([match.open]);
      } else {
        setOpenKeys([]);
      }
    }

    const local_theme = localStorage.getItem("dark_theme");
    set_balck_theme(local_theme === "dark" ? "dark" : "light");
  }, [location.pathname]);

  const handleMenuClick = ({ key }) => {
    const keyToPath = {
      1: "/",
      2: "courses",
      3: "packages",
      4: "all-packages",
      7: "/account",
      8: "/certificate",
      9: "/leaderboard",
    };

    const route = keyToPath[key];

    if (key === "50") {
      modal.confirm({
        title: "Are you sure you want to logout?",
        okText: "Logout",
        cancelText: "Cancel",
        onOk: () => {
          logout();
        },
      });
    } else if (route) {
      navigate(route);
      if (isMobile) setCollapsed(true); // mobile par navigate hone ke baad menu close
    }
  };

  const onOpenChange = (keys) => {
    setOpenKeys(keys);
  };

  const menuItems = [
    {
      key: "1",
      icon: <HomeOutlined />,
      label: "Dashboard",
    },
    {
      key: "2",
      icon: <ReadOutlined />,
      label: "My Courses",
    },
    {
      key: "3",
      icon: <AccountBookOutlined />,
      label: "My Packages",
    },
    // {
    //   key: "4",
    //   icon: <AccountBookOutlined />,
    //   label: "All Packages",
    // },
    // {
    //   key: "8",
    //   icon: <SnippetsOutlined />,
    //   label: "Live Test",
    // },
    {
      key: "8",
      icon: <BookOutlined />,
      label: "Certificates",
    },
    {
      key: "9",
      icon: <SignalFilled />,
      label: "Leaderboard",
    },
    {
      key: "7",
      icon: <SettingFilled />,
      label: "Account",
    },
    // {
    //   key: "9",
    //   icon: <NotificationFilled />,
    //   label: "Announcements",
    // },
    // {
    //   key: "50",
    //   icon: <UploadOutlined />,
    //   label: "Logout",
    // },
  ];

  const SIDEBAR_WIDTH = 230;
  const COLLAPSED_WIDTH = 80;

  return (
    <>
      {master_loder ? (
        <CulsightPageLoader />
      ) : (
        <Layout style={{ height: "100vh", overflow: "hidden" }}>
          {isMobile ? (
            <Drawer
              placement="left"
              open={!collapsed}
              onClose={() => setCollapsed(true)}
              bodyStyle={{ padding: 0 }}
              width={220}
              style={{
                backgroundColor: balck_theme === "dark" ? "#fff" : "#fff"

              }}
            >
              <div className="menu-logo" style={{ textAlign: "center" }}>
                <img alt="logo" src={balck_theme === "dark" ? Logo : Logo1} style={{ width: "120px", marginRight: "70px" }} />
              </div>
              <Menu
                className="gold-menu"
                style={{ marginTop: "70px" }}

                mode="inline"
                selectedKeys={selectedKeys}
                openKeys={openKeys}
                onOpenChange={onOpenChange}
                onClick={handleMenuClick}
                items={menuItems}
              />
            </Drawer>
          ) : (
            <Sider
              trigger={null}
              collapsible
              collapsed={collapsed}
              onCollapse={(v) => setCollapsed(v)}
              breakpoint="md"
              collapsedWidth={isMobile ? 0 : 80}
              style={{
                backgroundColor: balck_theme === "dark" ? "#fff" : "#fff",
                position: "fixed",
                left: 0,
                top: 0,
                bottom: 0,
                height: "100vh",
                overflow: "auto",
                borderRight: balck_theme === "dark" ? "1px solid rgba(0,0,0,0.1)" : "1px solid rgba(0,0,0,0.1)",
              }}
            >
              {/* Scrollable Content */}
              <div style={{ overflowY: "auto", height: "100%" }}>
                <div className="menu-logo" style={{ marginTop: "20px" }}>
                  <img alt="logo" src={balck_theme === "dark" ? Logo : Logo1} />
                </div>

                <Menu
                  style={{ marginTop: "70px" }}
                  className="gold-menu"
                  mode="inline"
                  selectedKeys={selectedKeys}
                  openKeys={openKeys}
                  onOpenChange={onOpenChange}
                  onClick={handleMenuClick}
                  items={menuItems}
                />
              </div>

              {/* Fixed Bottom Footer */}
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  width: "100%",
                  padding: "15px",
                  borderTop: balck_theme === "dark" ? "1px solid rgba(0,0,0,0.1)" : "1px solid rgba(0,0,0,0.1)",
                  backgroundColor: balck_theme === "dark" ? "#fff" : "#fff"
                }}
              >

                <div style={{ textAlign: "left" }}>
                  {/* <div style={{ marginBottom: "10px" }}><ThemeSetting set_theme_style={set_balck_theme} /></div> */}

                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <div
                      style={{
                        width: 35,
                        height: 35,
                        borderRadius: "50%",
                        background: "#1fa7a1",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#fff",
                      }}
                    >
                      {user?.user_info?.name?.charAt(0)?.toUpperCase() || "U"}
                    </div>
                    <div>
                      <div style={{ fontWeight: "bold" }}>{user?.user_info?.name}</div>
                      <div style={{ fontSize: "12px", opacity: 0.7 }}>
                        {user?.user_info?.email}
                      </div>
                    </div>
                  </div>

                  <div style={{ marginTop: "10px", color: "red", cursor: "pointer", marginLeft: "10px", fontSize: "16px", fontWeight: "600" }} onClick={() => {
                    modal.confirm({
                      title: "Are you sure you want to logout?",
                      okText: "Logout",
                      cancelText: "Cancel",
                      onOk: () => {
                        logout();
                      },
                    });
                  }}>
                    <LogoutOutlined /> Sign Out
                  </div>
                </div>
              </div>
            </Sider>
          )}

          <Layout
            style={{
              marginLeft: collapsed
                ? (isMobile ? 0 : COLLAPSED_WIDTH)
                : SIDEBAR_WIDTH,
              height: "100vh"
            }}
          ><Header
            style={{
              position: "fixed",
              top: 0,
              right: 0,
              left: collapsed
                ? (isMobile ? 0 : COLLAPSED_WIDTH)
                : SIDEBAR_WIDTH,
              zIndex: 1000,
              height: 64,
              backgroundColor: balck_theme === "dark" ? "#fff" : "#fff",
              borderBottom: balck_theme === "dark" ? "1px solid rgba(0,0,0,0.1)" : "1px solid rgba(0,0,0,0.1)",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0 10px"
            }}
          >

              <div style={{ display: "flex", alignItems: "center" }}>
                {isMobile && (
                  <Button
                    type="text"
                    icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                    onClick={() => setCollapsed(false)}
                    style={{
                      fontSize: "20px",
                      color: balck_theme === "dark" ? "#141414" : "#141414",
                    }}
                  />
                )}
                {!isMobile && (
                  <span style={{ fontWeight: "bold", fontSize: "20px" }}>Learner Panel</span>
                )}
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>

                <UserNotification />


                {!isMobile && <UserDropdown user={user} />}

                {isMobile && (
                  <Dropdown
                    placement="bottomRight"
                    trigger={["click"]}
                    dropdownRender={() => (
                      <div
                        style={{
                          padding: "12px",
                          backgroundColor: balck_theme === "dark" ? "#fff" : "#fff",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                          borderRadius: 8,
                          width: 220,
                        }}
                      >
                        <Row gutter={[12, 12]} justify="center">
                          {/* <Col span={24}>
                            {isMobile && (
                              <ThemeSetting set_theme_style={set_balck_theme} />
                            )}                          </Col> */}
                          <Col span={24}>
                            <UserDropdown user={user} />
                          </Col>
                        </Row>
                      </div>
                    )}
                  >
                    <Button
                      type="text"
                      icon={<SettingFilled style={{ fontSize: '25px', color: "#1fa7a1" }} />}
                      style={{
                        color: balck_theme ? "#141414" : "#141414",
                      }}
                    />
                  </Dropdown>
                )}
              </div>

            </Header>

            <Content
              style={{
                marginTop: 64,
                height: "calc(100vh - 64px)",
                overflowY: "auto",
                backgroundColor: balck_theme === "dark" ? "#e6e6e6ff" : "#e6e6e6ff"
              }}
            >
              <Outlet context={{ user, setUser }} />
            </Content>

          </Layout>
        </Layout>
      )}
    </>
  );
};

export default MasterTemplate;
